import LocalizedStrings from 'react-localization';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';

export default new LocalizedStrings(
  {
    de,
    en,
    fr,
    it
  },
  {
    logsEnabled: false
  }
);
